import './wounds.scss';

import React from 'react';

const Wounds = ({wounds}) => {
  wounds = +wounds;
  let woundMarkers = [];
  for (let index = 1; index <= wounds; index++) {
    if ((index/wounds)*100 > 60) {
      woundMarkers.push((
        <span key={index} className="wound-marker wounded"></span>
      ));
    } else {
      woundMarkers.push((
        <span key={index} className="wound-marker"></span>
      ));
    }

  }

  return (
    <span className="wounds">
      {woundMarkers.map((marker) => marker)}
    </span>
  );
};

export default Wounds;
